<template>
	<div>
		<v-autocomplete
			v-show="mandatorVisible"
			v-model="selectedMandator"
			:items="mandators"
			:search-input.sync="searchMandators"
			hide-selected
			label="Mandator"
			multiple
			persistent-hint
			chips
			return-object
			@change="emitChange"
		/>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'ArcCustomMandatorFilter',
	components: {
	},
	props: ['appNameShort', 'disable'],
	data() {
		return {
			selectedMandator: [],
			mandators: ['Mandators could not be loaded'],
			searchMandators: null,
			mandatorVisible: true,
		}
	},
	watch: {
		mandators: {
			handler() {
				this.mandatorAutofill()
			},
		},
		selectedMandator: {
			handler() {
				this.popFirstMandator(this.selectedMandator)
			},
		},
	},
	methods: {
		async getMandators(appNameShort) {
			try {
				let mandatorsRes
				switch (appNameShort) {
				case 'rs':
					mandatorsRes = await axios.get(`${config.baseAPIurl}/registration-report/mandator?appNameShort=${appNameShort}`)
					break
				case 'be':
					mandatorsRes = await axios.get(`${config.baseAPIurl}/billing-engine/mandators?appNameShort=${appNameShort}`)
					break
				default:
					throw new Error()
				}
				this.mandators = mandatorsRes.data
			} catch (e) {
				this.$emit('mandatorError')
			}
		},
		popFirstMandator(mandators) {
			// remove the first item of the mandator array -> only one at the time
			if (mandators.length > 1) {
				this.selectedMandator.shift()
			}
		},
		mandatorAutofill() {
			if (this.mandators.length === 1) {
				this.selectedMandator = this.mandators
				this.mandatorVisible = false
				this.emitChange()
			}
		},
		emitChange() {
			this.$emit('changeSelectedValue', this.selectedMandator)
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators(this.appNameShort)
		})
	},
}
</script>

<style>

</style>
